module.exports = {
    DELETE_REMOTE_WORK: "Are you sure you want to delete this Remote Work Request?",
    DELETE_REMOTE_WORK_COMMENT: "Are you sure you want to delete this remote work comment?",
    DELETE_ATTACHMENT: "Are you sure you want to delete this remote work attachement?"
}